import { history } from 'utils/history';
import { matchApplicantsListPath } from 'utils/urlUtils';

import { isOtherSurfaceOpen } from './trigger/guards';

let open: (() => boolean) | undefined;

export const isHiddenGameSurfaceAvailable = (): boolean =>
  matchApplicantsListPath(history.location.pathname) !== null &&
  !isOtherSurfaceOpen(document);

export const openHiddenGame = (): boolean =>
  open && isHiddenGameSurfaceAvailable() ? open() : false;

export const setSplashOpener = (opener?: () => boolean): void => {
  open = opener;
};

declare global {
  interface Window {
    openHiddenGame?: typeof openHiddenGame;
  }
}
